import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';
import { RunCostResponse } from '../api.shared.types';
import { BatchCostRequest } from './batches.api.types';

export const getBatchCostApi = async ({ recipeId, numberOfRuns, nodes, edges }: BatchCostRequest) => {
  const res = await safeAxios.post<RunCostResponse>(
    API_ROUTES.batches.cost({ recipeId }),
    { numberOfRuns, nodes, edges },
    { 'axios-retry': { retries: 0 } },
  );
  return res.data;
};
